"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRut = void 0;
const format_1 = require("../format");
function validateRut(userDocument) {
    if ((0, format_1.isRepeatedDigitText)(userDocument)) {
        return false;
    }
    const documentValue = userDocument.replace('.', '').replace('-', '');
    const documentNumber = documentValue.slice(0, -1);
    let verifyingDigit = documentValue.slice(-1).toUpperCase();
    if (documentNumber.length < 7) {
        return false;
    }
    let sum = 0;
    let multiple = 2;
    for (let i = 1; i <= documentNumber.length; i += 1) {
        const result = multiple * Number(documentValue.charAt(documentNumber.length - i));
        sum += result;
        multiple = multiple < 7 ? multiple + 1 : 2;
    }
    const expectedVerifyingDigit = String(11 - (sum % 11));
    if (verifyingDigit === 'K') {
        verifyingDigit = '10';
    }
    if (Number(verifyingDigit) === 0) {
        verifyingDigit = '11';
    }
    if (expectedVerifyingDigit === verifyingDigit) {
        return true;
    }
    return false;
}
exports.validateRut = validateRut;
